const n = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "tiff", "ico", "avif"];
function s(e) {
  var t;
  const i = (t = e.name.split(".").pop()) == null ? void 0 : t.toLowerCase();
  return e.type.startsWith("image/") || n.includes(i ?? "-");
}
export {
  s as isImageFile
};
